/**
 * Generates the appropriate tenant URL based on the environment configuration
 */
export function getTenantUrl(subdomain: string): string {
  const baseDomain = (import.meta as any).env?.VITE_TENANT_BASE_DOMAIN || 'lawmabase.com';
  
  // For development environment (tenant.fintake.ai), use the domain directly
  if (baseDomain === 'tenant.fintake.ai') {
    return `https://${baseDomain}`;
  }
  
  // For production environment (lawmabase.com), use subdomain pattern
  return `https://${subdomain}.${baseDomain}`;
}

/**
 * Formats the tenant display URL for UI purposes
 */
export function getTenantDisplayUrl(subdomain: string): string {
  const baseDomain = (import.meta as any).env?.VITE_TENANT_BASE_DOMAIN || 'lawmabase.com';
  
  // For development environment, show just the domain
  if (baseDomain === 'tenant.fintake.ai') {
    return baseDomain;
  }
  
  // For production environment, show subdomain.domain format
  return `${subdomain}.${baseDomain}`;
}

export const EXPERT_APP_DOMAIN = 'lawmabase.com';

export function defaultExpertAppSubdomain(subdomain: string): string {
  return `${subdomain}-ea`;
}
